import React from 'react'
import './scss/PropertyThumb.scss'

const PropertyThumb = ({property}) => {
    return (
        <div className="property-card" key={property._id}>
            <a href={`/propertyDetail`}>
                <div className="property-card-container" >
                    <span className="rental-type">{property.rental_type}</span>
                    <div className="images" style={{backgroundImage:`url(${property.images[0]})`}}></div>
                    <div className="mt-1">
                        <h5>${property.price}/month</h5>
                        <small><i>{property.address}</i></small>
                        <p className="text-left"><span>Bedrooms:</span> 2 <span className="ml-3">Bathrooms:</span> 1</p>
                        <small className="text-right d-block text-secondary">{property.day} day ago</small>
                    </div>
                    
                </div>
            </a>
           
        </div>
    )
}

export default PropertyThumb